import React from "react";
import { getKblSchedule } from "api/kbl/kbl";
import { startOfWeek, isSameMonth } from "date-fns";
import ScheduleCalendar from "./SonicBoom/ScheduleCalendar";
import ScheduleBox from "./SonicBoom/ScheduleBox";

export const kblTeamLogo = {
  kt: require("../../assets/img/kbl/team/kt.png"),
  sk: require("../../assets/img/kbl/team/sk.png"),
  hd: require("../../assets/img/kbl/team/hd.png"),
  lg: require("../../assets/img/kbl/team/lg.png"),
  kcc: require("../../assets/img/kbl/team/kcc.png"),
  kgc: require("../../assets/img/kbl/team/kgc.png"),
  sono: require("../../assets/img/kbl/team/sono.png"),
  pega: require("../../assets/img/kbl/team/pega.png"),
  ss: require("../../assets/img/kbl/team/ss.png"),
  db: require("../../assets/img/kbl/team/db.png"),
  kaf: require("../../assets/img/kbl/team/kaf.png"),
};

const groupByWeek = (dataList) => {
  const weeks = {};
  let weekNumber = 1;
  let currentWeekStart = null;

  if (dataList.length === 0) {
    return weeks;
  }

  // 데이터 리스트를 날짜순으로 정렬
  const sortedData = dataList.sort((a, b) => {
    return a.gameDate.localeCompare(b.gameDate);
  });

  sortedData.forEach((item) => {
    const year = parseInt(item.gameDate.substring(0, 4));
    const month = parseInt(item.gameDate.substring(4, 6)) - 1; // 월은 0부터 시작
    const day = parseInt(item.gameDate.substring(6, 8));
    const date = new Date(year, month, day);

    // 주의 시작을 일요일로 설정
    let weekStart = startOfWeek(date, { weekStartsOn: 0 });

    // 해당 월의 첫 주인 경우, 주 시작일을 해당 월의 첫 날로 설정
    if (currentWeekStart === null) {
      const firstOfMonth = new Date(year, month, 1);
      if (!isSameMonth(weekStart, firstOfMonth)) {
        weekStart = firstOfMonth;
      }
      currentWeekStart = weekStart;
    }

    // 새로운 주가 시작되면 이전 주와 현재 주 사이의 빈 주를 추가
    while (weekStart > currentWeekStart) {
      const weekKey = `${currentWeekStart.getMonth() + 1}월 ${weekNumber}주`;
      if (!weeks[weekKey]) {
        weeks[weekKey] = [];
      }
      weekNumber += 1;
      currentWeekStart = addWeeks(currentWeekStart, 1);
    }

    // 주 키 생성
    const currentWeekKey = `${currentWeekStart.getMonth() + 1}월 ${weekNumber}주`;

    if (!weeks[currentWeekKey]) {
      weeks[currentWeekKey] = [];
    }
    weeks[currentWeekKey].push(item);
  });

  // 마지막 주의 빈 주들을 추가
  const lastItem = sortedData[sortedData.length - 1];
  const lastYear = parseInt(lastItem.gameDate.substring(0, 4));
  const lastMonth = parseInt(lastItem.gameDate.substring(4, 6)) - 1;
  const lastDay = parseInt(lastItem.gameDate.substring(6, 8));
  const lastDate = new Date(lastYear, lastMonth, lastDay);
  const endOfMonth = new Date(lastYear, lastMonth + 1, 0);

  while (currentWeekStart <= endOfMonth) {
    const weekKey = `${currentWeekStart.getMonth() + 1}월 ${weekNumber}주`;
    if (!weeks[weekKey]) {
      weeks[weekKey] = [];
    }
    weekNumber += 1;
    currentWeekStart = addWeeks(currentWeekStart, 1);
  }

  return weeks;
};

// Helper 함수: 날짜에 주를 더함
const addWeeks = (date, weeks) => {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + weeks * 7);
  return newDate;
};

const SonicBoomSchedule = () => {
  const [data, setData] = React.useState({ list: [] });
  const [screenChange, setScreenChange] = React.useState(true);
  const currentDate = new Date();
  const initialYear = currentDate.getFullYear();
  const initialMonth = currentDate.getMonth() + 1;
  const formatMonth = (month) => (month < 10 ? `0${month}` : `${month}`);

  const [year, setYear] = React.useState(initialYear);
  const [month, setMonth] = React.useState(initialMonth);

  React.useEffect(() => {
    getKblSchedule({ date: `${year}${formatMonth(month)}` })
      .then((response) => {
        // 데이터를 복사한 후 gameDate를 기준으로 정렬
        const sortedList = [...response.data.data.list].sort((a, b) => {
          return a.gameDate.localeCompare(b.gameDate);
        });
        setData({ ...response.data.data, list: sortedList });
      })
      .catch((error) => {
        console.error("Error fetching KBL notice:", error);
      });
  }, [year, month]);

  const handlePrevMonth = () => {
    if (month === 1) {
      setMonth(12);
      setYear((prevYear) => prevYear - 1);
    } else {
      setMonth((prevMonth) => prevMonth - 1);
    }
  };

  const handleNextMonth = () => {
    if (month === 12) {
      setMonth(1);
      setYear((prevYear) => prevYear + 1);
    } else {
      setMonth((prevMonth) => prevMonth + 1);
    }
  };

  const groupedWeeks = groupByWeek(data.list);

  return (
    <div className="kbl_sonicboom_schedule" style={{ height: data.list.length > 0 && screenChange ? "100%" : "100vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          width: "345px",
          padding: "20px 0px",
        }}
      >
        <div
          style={{ display: "flex", flexDirection: "row", justifyContent: "left", alignItems: "center", width: "72px", marginLeft: "10px" }}
        >
          <button onClick={handlePrevMonth} style={{ height: "20px", fontSize: "16px", marginTop:'3px', color: "#1a1718" }}>
            {"<"}
          </button>
          <div
            style={{
              borderBottom: "1px solid black",
              width: "80px",
              margin: "10px 22px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: "20px",
              fontWeight: "bold",
            }}
          >
            {year}.{month}
          </div>
          <button onClick={handleNextMonth} style={{ height: "20px", fontSize: "16px", marginTop:'3px', color: "#1a1718" }}>
            {">"}
          </button>
        </div>
        {data.list.length > 0 && !screenChange && (
        <button
          onClick={() => setScreenChange(!screenChange)}
          style={{ width: "24px", height: "24px", padding: "2px", marginRight: "12px" }}
        >
            <img
              src={require("../../assets/img/kbl/weekly_view.png")}
              alt="스크린 변경"
              style={{ width: "24px", height: "24px" }}
            />
        </button>
          )}
      </div>

      {screenChange ? (
        <div>
          {data && data.list.length > 1 ? (
            Object.keys(groupedWeeks).map((weekKey, idx) => (
              <div key={idx} style={{ marginBottom: "40px" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                  <div style={{ fontSize: "15px", color: "#717781", fontWeight: "bold", textAlign: "center"  }}>
                    {weekKey}
                  </div>
                  {idx === 0 && (
                    <button
                      onClick={() => setScreenChange(!screenChange)}
                      style={{ width: "24px", height: "24px"}}
                    >
                      <img
                        src={require("../../assets/img/kbl/monthly_view.png")}
                        alt="스크린 변경"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </button>
                  )}
                </div>
                {groupedWeeks[weekKey].length > 0 ? groupedWeeks[weekKey].map((item, idx) => (
                  <ScheduleBox data={item} key={idx} />
                )) : <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "295px",
                  height: "142px",
                  borderRadius: "24px",
                  padding: "12px 20px",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                  marginBottom: "8px"
                }}
              >
                <img
                  src={require("../../assets/img/kbl/no_plan.png")}
                  alt="noPlan"
                  style={{ width: "32px", height: "32px", marginBottom: "8px" }}
                />
                <div style={{ fontSize: "15px", fontWeight: "bold", color: "#abadb2" }}>경기 일정이 없습니다.</div>
              </div>}
              </div>
            ))
          ) : (
            <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "295px",
                  height: "142px",
                  borderRadius: "24px",
                  padding: "12px 20px",
                  backgroundColor: "white",
                  boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={require("../../assets/img/kbl/no_plan.png")}
                  alt="noPlan"
                  style={{ width: "32px", height: "32px" }}
                />
                <div style={{ fontSize: "15px", fontWeight: "bold", color: "#abadb2" }}>경기 일정이 없습니다.</div>
              </div>
          )}
        </div>
      ) : (
        <div style={{ width: "325px" }}>
          <ScheduleCalendar year={year} month={month} data={data} />
        </div>
      )}
    </div>
  );
};

export default SonicBoomSchedule;